import { render, staticRenderFns } from "./world-compliance.html?vue&type=template&id=10135238&scoped=true&"
import script from "./world-compliance.js?vue&type=script&lang=js&"
export * from "./world-compliance.js?vue&type=script&lang=js&"
import style0 from "./world-compliance.scss?vue&type=style&index=0&id=10135238&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=10135238&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10135238",
  null
  
)

export default component.exports